import { useState } from 'react'
import {
  Toolbar,
  SaveButton,
  DeleteButton,
  Button,
  useRecordContext,
  useDataProvider,
  useNotify,
  useRefresh,
} from 'react-admin'
import { CircularProgress } from '@mui/material'

const toolbarStyles = {
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
  },
  // convertButton: {
  //   // position: 'fixed',
  //   bottom: '20px',
  //   right: '20px',
  //   zIndex: 1000,
  //   backgroundColor: '#1976d2',
  //   color: 'white',
  //   padding: '12px 24px',
  //   fontSize: '16px',
  //   minWidth: '180px',
  //   height: '48px',
  //   borderRadius: '8px',
  //   boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
  //   '&:hover': {
  //     backgroundColor: '#1565c0',
  //     boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)'
  //   }
  // }
}

const AiBookToolbar = props => {
  const { styles, disabled } = props
  const [isConverting, setIsConverting] = useState(false)
  const record = useRecordContext()
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const refresh = useRefresh()

  const handleConvertToBook = async () => {
    if (!record?.id) {
      notify('No AI Book ID found', { type: 'error' })
      return
    }

    setIsConverting(true)
    try {
      await dataProvider.create('ai-books/convert-to-book', {
        data: { aiBookId: record.id },
      })
      notify('AI Book conversion initiated successfully', { type: 'success' })
      refresh()
    } catch (error) {
      notify(`Conversion failed: ${error.message}`, { type: 'error' })
    } finally {
      setIsConverting(false)
    }
  }

  return (
    <>
      <Toolbar
        {...props}
        style={{
          ...toolbarStyles.toolbar,
          ...styles,
        }}>
        <div style={{ display: 'flex', gap: '10px' }}>
          <SaveButton disabled={disabled} />
          <Button
            label="Convert To Book Entity"
            onClick={handleConvertToBook}
            disabled={disabled || isConverting || !record?.id}
            variant="contained"
            color="secondary">
            {isConverting && (
              <CircularProgress size={20} style={{ marginRight: 8 }} />
            )}
          </Button>
        </div>
        <DeleteButton undoable={false} />
      </Toolbar>
    </>
  )
}

export default AiBookToolbar
